<template>
  <div>
    <command-panel
        title="Щитовое оборуд."
        :save-button="true"
        :save-enabled="valid"
        :delete-button="true"
        :photo-button="true"
        :voice-record-button="true"
        :file-button="true"
        :coords-button="true" 
        @save="saveItem"
        @delete="showConfirmDelete=true"
        @photo="makePhoto"
        @coords="getCurrentPosition" 
        @voiceRecord="showVoiceRecorder=true"
        @file="showFilesList=true"
    />

    <v-form v-model="valid" class="mt-2">

          <v-tabs v-model="tab">
            <v-row justify="center">
              <v-tab>Данные</v-tab>
              <v-tab>Фото</v-tab>
              <v-tab>Карта</v-tab>
              <v-tab>Контроль</v-tab>
            </v-row>
            <v-tab-item>
              <v-card outlined style="margin-top: 2px; height: calc(100vh - 16rem); display: flex !important; flex-direction: column; padding-top: 10px; padding-bottom: 10px;">
                <v-card-text style="flex-grow: 1; overflow: auto;">
                
                  <v-text-field
                      outlined
                      dense
                      label="Наименование (обязательное поле)"
                      type="text"
                      v-model="model.name"
                      :rules="[required()]"
                      autocomplete="off"
                  ></v-text-field>

                  <v-select
                      outlined
                      dense
                      label="Сетевой комплекс"
                      v-model="model.powerGridComplexId"
                      :items="powerGridComplex"
                      item-text="name"
                      item-value="id"
                      :clearable="true"
                      @click:clear="$nextTick(() => model.powerGridComplexId=null)"
                  ></v-select>

                  <v-select 
                    outlined
                    dense 
                    label="Класс напряжения (кВ)" 
                    v-model="model.voltageClass" 
                    :items="voltageClass"
                    :clearable="true" 
                    @click:clear="$nextTick(() => model.voltageClass=null)"
                  ></v-select>

                  <v-textarea
                    outlined
                    dense 
                    label="Описание (доп. информация)" 
                    v-model="model.description" 
                    autocomplete="off"
                  ></v-textarea>

                </v-card-text>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card outlined style="margin-top: 2px; height: calc(100vh - 16rem); padding: 10px;">
                  <photo-carousel :images="images" @photo="makePhoto" />
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card outlined style="margin-top: 2px; height: calc(100vh - 16rem); padding: 10px;">
                <yandex-maps :obj="model" />
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card outlined style="margin-top: 2px; height: calc(100vh - 16rem); display: flex !important; flex-direction: column; padding-top: 10px; padding-bottom: 10px;">
                <v-card-text style="flex-grow: 1; overflow: auto;">
                
                  <h3 style="margin-bottom: 0.5rem;">Замеры нагрузки (токи):</h3>

                  <v-text-field
                      outlined
                      dense
                      label="Фаза A"
                      type="number"
                      v-model="model.ampereMeasurementA"
                      autocomplete="off"
                  ></v-text-field>

                  <v-text-field
                      outlined
                      dense
                      label="Фаза B"
                      type="number"
                      v-model="model.ampereMeasurementB"
                      autocomplete="off"
                  ></v-text-field>

                  <v-text-field
                      outlined
                      dense
                      label="Фаза C"
                      type="number"
                      v-model="model.ampereMeasurementC"
                      autocomplete="off"
                  ></v-text-field>

                  <v-text-field
                      outlined
                      dense
                      label="Дата замера нагрузки"
                      type="date"
                      v-model="model.ampereMeasurementDate"
                      autocomplete="off"
                  ></v-text-field>

                  <h3 style="margin-bottom: 0.5rem;">Замеры температуры контактов:</h3>

                  <v-text-field
                      outlined
                      dense
                      label="Фаза A"
                      type="number"
                      v-model="model.contactTemperatureA"
                      autocomplete="off"
                  ></v-text-field>

                  <v-text-field
                      outlined
                      dense
                      label="Фаза B"
                      type="number"
                      v-model="model.contactTemperatureB"
                      autocomplete="off"
                  ></v-text-field>

                  <v-text-field
                      outlined
                      dense
                      label="Фаза C"
                      type="number"
                      v-model="model.contactTemperatureC"
                      autocomplete="off"
                  ></v-text-field>

                  <v-text-field
                      outlined
                      dense
                      label="Дата замера температуры"
                      type="date"
                      v-model="model.contactTemperatureDate"
                      autocomplete="off"
                  ></v-text-field>

                  <h3 style="margin-bottom: 0.5rem;">Состояние контактов:</h3>

                  <v-select 
                    outlined
                    dense 
                    label="Состояние" 
                    v-model="model.condition" 
                    :items="conditionOptions"
                    :clearable="true" 
                    @click:clear="$nextTick(() => model.condition=null)"
                  ></v-select>

                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs>

    </v-form>

    <input type="file" accept="image/*" capture="environment" id="photoInput" @change="savePhoto" hidden>

    <voice-recorder
        v-if="showVoiceRecorder"
        @ok="saveVoiceRecord"
        @cancel="showVoiceRecorder=false"
    />

    <confirm
        v-if="showConfirmDelete"
        header="Удалить?"
        :text="model.name"
        @ok="showConfirmDelete = false; deleteItem();"
        @cancel="showConfirmDelete = false"
    />

    <files-list
        v-if="showFilesList"
        :holder-id="model.id"
        @close="showFilesList=false"
        @deleteFiles="deleteFiles"
    />

  </div>
</template>

<script>
import CommandPanel from "@/components/common/commandPanel";
import validations from "@/validations";
import Confirm from "@/components/common/confirm";
import PhotoCarousel from "@/components/common/photoCarousel";
import {v4 as uuidv4} from "uuid";
import VoiceRecorder from "@/components/common/voiceRecorder";
import FilesList from "@/components/common/filesList";
import common from "@/common";
import YandexMaps from '@/components/common/yandexMaps.vue';

export default {
  name: 'switchboardEquipmentItem',

  components: { FilesList, VoiceRecorder, PhotoCarousel, Confirm, CommandPanel, YandexMaps },

  props: {
    param: String, // Может быть передан id объекта, если редактируем или пустое значение для новых
  },

  created() {
    this.loadData()
  },

  data() {
    return {
      itemType: 'switchboardEquipment',
      loading: false,
      valid: false,
      images: [],
      showConfirmDelete: false,
      showVoiceRecorder: false,
      showFilesList: false,
      src: null,
      ...validations,
      tab: 0,
      model: {
        id: null,
        name: null,
        powerGridComplexId: null,
        locality: null,
        lat: null,
        lon: null,
        type: null,
        voltageClass: null,
        ampereMeasurementA: null,
        ampereMeasurementB: null,
        ampereMeasurementC: null,
        ampereMeasurementDate: null,
        contactTemperatureA: null,
        contactTemperatureB: null,
        contactTemperatureC: null,
        contactTemperatureDate: null,
        condition: null,
        conditionDate: null,
        description: null,
      },
      powerGridComplex: [],
      voltageClass: [0.23, 0.4, 6, 10],
      conditionOptions: ['Контакты в норме', 'Есть нагрев', 'Предаварийная ситуация'],
    }
  },

  methods: {
    async loadData() {
      this.powerGridComplex = await common.getList('powerGridComplex')
      const item = await common.getItem(this.itemType, this.param)
      if (item) {
        Object.assign(this.model, item)
        this.images = await common.getImages(this.model.id)
      }
      else {
        this.model.id = uuidv4()
        this.model.powerGridComplexId = await common.getDefaultPowerGridComplexId()
      }
    },

    async saveItem() {
      this.loading = true
      this.model.description = this.model.description || ""
      await common.saveItem(this.itemType, this.model)
      this.loading = false
      this.$emit('mainPage')
    },

    async deleteItem() {
      await common.deleteItem(this.itemType, this.model.id)
      this.$emit('mainPage')
    },

    makePhoto() {
      document.getElementById('photoInput').click()
    },

    async savePhoto(event) {
      if (event.target.files.length) {
        await common.savePhoto(this.itemType, this.model.id, event.target.files[0], this)
        setTimeout(async () => {
          this.images = await common.getImages(this.model.id)
        }, 300)
        this.tab = 1
      }
    },

    async saveVoiceRecord(voice) {
      this.showVoiceRecorder = false
      if (voice && Array.isArray(voice) && voice.length) {
        await common.saveVoiceRecord(this.itemType, this.model.id, voice)
      }
    },

    async deleteFiles() {
      this.images = await common.getImages(this.model.id)
    },

    getCurrentPosition_OLD() {
      this.loading = true;
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.model.lat = null
          this.model.lon = null
          this.model.lat = position.coords.latitude
          this.model.lon = position.coords.longitude
          this.loading = false;
        },
        function (error) {
          this.loading = false;
          alert(error.message)
        }
      )
      this.tab = 2
    },

    getCurrentPosition() {
      this.loading = true;
      let coords = [];
      common.getCurrentPositionArray(coords);
      setTimeout(() => {
        if (coords.length) {
          const averageCoordinates = common.getAverageCoordinates(coords);
          this.model.lat = averageCoordinates.lat
          this.model.lon = averageCoordinates.lon
        } else {
          this.model.lat = null
          this.model.lon = null
        }
        this.tab = 2;
        this.loading = false;
      }, 300);
    },

  },
}
</script>
